'use client';

import { forwardRef } from 'react';
import type { ComponentPropsWithoutRef } from 'react';
import type { UnstyledButtonProps as MantineUnstyledButtonProps } from '@mantine/core';
import { UnstyledButton as MantineUnstyledButton } from '@mantine/core';

type UnstyledButtonProps = MantineUnstyledButtonProps & ComponentPropsWithoutRef<'button'>;

export const UnstyledButton = forwardRef<HTMLButtonElement, UnstyledButtonProps>((props, ref) => {
  return <MantineUnstyledButton {...props} ref={ref} />;
});

UnstyledButton.displayName = 'UnstyledButton';
